import { RECIEVE_RULETEXT, REQUEST_RULETEXT } from '../actions/a.ruletext'

import Store from '../store'

const RuleText = (state = Store.RuleText, action) => {
    switch(action.type) {
        case REQUEST_RULETEXT:
            return {
                ...state,
                isFetching: true,
            }
        case RECIEVE_RULETEXT:
            return {
                ...state,
                item: action.payload,
                isFetching: false,
            }
        default:
            return state
    }
} 

export default RuleText